
// Initialize local fallback if Supabase connection fails
export const initializeLocalFallback = async () => {
  console.log('Initializing local fallback...');
  
  const createDefaultData = (key: string, defaultValue: any) => {
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, JSON.stringify(defaultValue));
    }
  };
  
  // Initialize with empty arrays instead of mock data
  createDefaultData('attendees', []);
  createDefaultData('adminActions', []);
  createDefaultData('adminState', {
    lastActivity: new Date().toISOString(),
    activeAdmins: [],
    lastSync: new Date().toISOString()
  });
  
  console.log('Local fallback initialized');
  return true;
};
